export const crmMessageSchedule = {
  notSelected: "選択されていません",
  selectMessageGroup: "右のリストからメッセージグループを選択してください",
  selectMessageGroupToChange:
    "変更する場合は右のリストからメッセージグループを選択してください",
  testSend: "テスト送信",
};
